module.exports = __webpack_public_path__ + "img/merge-companies.47de4d97.svg";